module.exports = __webpack_public_path__ + "static/media/3_step 1.396fb354.PNG";